import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { KundenPopoverPageRoutingModule } from './kunden-popover-routing.module';

import { KundenPopoverPage } from './kunden-popover.page';

import { ComponentsModule } from "../../../components/components.module"

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    KundenPopoverPageRoutingModule
  ],
  declarations: [KundenPopoverPage]
})
export class KundenPopoverPageModule {}
